import type { TMotionActivityType } from '../types/tracking'

/**
 * Returns the motion activity and its emoji based on the motion activity type
 */
export const getMotionActivity = (motionActivity: TMotionActivityType | null) => {
  if (!motionActivity || motionActivity === 'unknown') return null

  const formattedMotionActivity = motionActivity.replace(/_/g, ' ')
  const motionEmoji = {
    in_vehicle: '🚚',
    on_bicycle: '🚴',
    on_foot: '👟',
    running: '🏃',
    still: '🏡',
    walking: '👟'
  }

  return {
    activity: formattedMotionActivity.charAt(0).toUpperCase() + formattedMotionActivity.slice(1),
    emoji: motionEmoji[motionActivity]
  }
}
